import { Form } from "antd"
import { Group, SelectInput } from "components/common"
import { t } from "i18next"
import PaymentProofImageUpload from "../../paymentProofImageUpload"
import { PAYMENTS_FORM_LIST_NAME } from "../utils/paymentUtils"

const AccountantSection = ({ form, accountantData, isLoadingAccountant, platformKey, projectId, listFieldName }) => (
  <Group template="repeat(2, 1fr)" gap="6px 32px">
    <Form.Item
      preserve
      name={[listFieldName, "regional_accountant"]}
      label={t("Accountant")}
      required
      rules={[{ validator: (_, value) => (!value ? Promise.reject(t("Accountant is Required")) : Promise.resolve()) }]}
    >
      <SelectInput placeholder={t("Choose Accountant")} options={accountantData} inputLoading={isLoadingAccountant} />
    </Form.Item>
    <Form.Item preserve name={[listFieldName, "accountantReceipt"]} label={t("Receipt")}>
      <PaymentProofImageUpload
        setFiles={data =>
          form.setFieldValue([PAYMENTS_FORM_LIST_NAME, listFieldName, "accountantReceipt"], data)
        }
        platformKey={platformKey}
        projectId={projectId}
        paymentProofProps={{
          attachmentTypeId: 1,
        }}
      />
    </Form.Item>
  </Group>
)

export default AccountantSection
